import React, { useEffect, useState } from 'react'
import { Text } from '../../../../modules/Dashboard'
import { AnimatePresence, motion } from "framer-motion"
import { defaultTransition, IMG_SIZE } from './common'
import { HorizontalGradient } from './HorizontalGradient'
import Spinner from './Spinner'
import { VerticalGradient } from './VerticalGradient'
import TickIcon from '../../../../components/icons/TickIcon'
import { PulseLoader } from 'react-spinners'

const ITEMS = [
    { title: 'loading-step-5-item-1' },
    { title: 'loading-step-5-item-2' },
    { title: 'loading-step-5-item-3' },
]

const Step5 = ({ done }) => {
    let itemsInterval;
    const [phase, setPhase] = useState("image"); // "image" | "items"
    const [enabledItems, setEnabledItems] = useState([]);

    const handleAnimationComplete = (index) => {
        setTimeout(() => {
            setEnabledItems((prev) => [...prev, index]);
        }, 2500);
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            setPhase("items");
        }, 5000);

        return () => {
            clearTimeout(timer);
            clearTimeout(itemsInterval);
        }
    }, []);


    return (
        <>
            {
                done &&
                <>
                    <VerticalGradient className={"absolute top-0 left-0 !w-[1px] !h-[428px]"} done />
                    <VerticalGradient className={"absolute top-0 right-0 !w-[1px] !h-[428px]"} done />
                </>
            }
            <div className='absolute top-3 ltr:right-3 rtl:left-3'>
                <Spinner done={done} />
            </div>

            <div className='flex flex-col items-start gap-5'>
                {/* Title */}
                <motion.div
                    initial={{ x: -500, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    transition={defaultTransition}
                    className='max-w-[250px]'
                >
                    <Text tid={"loading-title-step-5"} className={`text-2xl text-wrap ${done ? "!text-success" : "!text-warn"}`} />
                </motion.div>

                {/* Desc */}
                <motion.div
                    initial={{ x: 500, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    transition={defaultTransition}
                    className='mt-5'
                >
                    <Text tid={"loading-desc-step-5"} className='! opacity-90' />
                </motion.div>

                <HorizontalGradient x={-400} done={done} />


                <AnimatePresence mode="wait">
                    {/* Phase rendering */}
                    <motion.div
                        key={phase}
                        initial={{ y: 0, x: 100, opacity: 0 }}
                        animate={{ y: 0, x: 0, opacity: 1 }}
                        exit={{ y: 0, x: -200, opacity: 0 }}
                        transition={{ ...defaultTransition, delay: 0.5 }}
                        className='w-full'
                    >
                        {phase === "image" && (
                            <img
                                src={require('../../assets/loading/support-and-resistance.webp')}
                                alt='support-&-resistance'
                                width={IMG_SIZE.width} height={IMG_SIZE.height} className='object-cover rounded-xl'
                            />
                        )}

                        {phase === "items" && (
                            <div className='flex flex-col gap-3 w-full'>
                                {ITEMS.map((item, index) => {
                                    const isEnabled = enabledItems.includes(index);

                                    return (
                                        <motion.div
                                            key={index}
                                            initial={{ y: 0, opacity: 0, x: index % 2 === 0 ? 250 : -250 }}
                                            animate={{ y: 0, opacity: 1, x: 0 }}
                                            transition={{ delay: (index + 1) / 0.9, duration: 0.5 }}
                                            onAnimationComplete={() => handleAnimationComplete(index)}
                                            className={`flex items-center justify-between gap-2 p-2 w-full rounded-md transition-colors ${isEnabled ? "!bg-[#1D1F23]" : "bg-[#000000]"}`}
                                        >
                                            <Text tid={item.title} className={`${isEnabled ? "" : "opacity-60"}`} />
                                            {isEnabled ? (
                                                <div className='flex items-center gap-1'>
                                                    <Text tid="uploaded" className='!text-success text-sm' />
                                                    <span className={`p-1 rounded-md ${isEnabled ? "bg-success" : "bg-[#ACACAC]"}`}>
                                                        <TickIcon size={13} color={isEnabled ? '#fff' : '#666'} />
                                                    </span>
                                                </div>
                                            ) : (
                                                <PulseLoader color='#00c795 ' size={6} speedMultiplier={0.5} />
                                            )}
                                        </motion.div>
                                    );
                                })}
                            </div>
                        )}
                    </motion.div>
                </AnimatePresence>


            </div>
        </>
    );
};


export default Step5